var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DataPieChart component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDataPieChart extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7495 2.63448V11.6893L19.152 18.0918C20.5504 16.4516 21.3945 14.3244 21.3945 12C21.3945 7.06372 17.5876 3.01662 12.7495 2.63448ZM19.6204 19.786C19.6515 19.7633 19.6813 19.7379 19.7094 19.7098C19.7375 19.6818 19.7629 19.652 19.7856 19.6209C21.7088 17.6562 22.8945 14.9666 22.8945 12C22.8945 5.98285 18.0166 1.105 11.9995 1.10498C11.9995 1.10498 11.9995 1.10498 11.9995 1.10498C5.98235 1.10498 1.10449 5.98284 1.10449 12C1.10449 18.0171 5.98235 22.895 11.9995 22.895C14.9661 22.895 17.6557 21.7093 19.6204 19.786ZM18.0914 19.1525L11.4692 12.5303C11.3285 12.3897 11.2495 12.1989 11.2495 12V2.63448C6.41144 3.0166 2.60449 7.06371 2.60449 12C2.60449 17.1887 6.81078 21.395 11.9995 21.395C14.3239 21.395 16.4511 20.5509 18.0914 19.1525Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDataPieChart.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDataPieChart.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDataPieChart.prototype, "size", void 0);
if (customElements.get('cat-icon-data-pie-chart') === undefined) {
    customElements.define('cat-icon-data-pie-chart', BlocksIconDataPieChart);
}
